import React from "react";
import TopBar from "./TopBar"


const ThoughtsPage = () => {
  return (
    <>
      <TopBar/>
    <div className="min-h-screen flex flex-col items-center bg-heroBg text-astro">
      {/* Hero Section */}
      <section className="w-full text-center py-20">
        <h1 className="text-5xl font-bold">Financial Thoughts & Wisdom</h1>
        <p className="mt-4 text-lg text-gray-700">Insights, reflections, and strategies from Astro Trader.</p>
      </section>

      {/* Featured Thoughts */}
      <section className="mt-10 max-w-3xl">
        {["The Power of Patience in Investing", "Risk & Reward: Lessons from the Cosmos", "Timing the Market with Astrology"].map((thought, i) => (
          <div key={i} className="mb-8 p-6 bg-white shadow-lg rounded-lg hover:shadow-xl transition">
            <h3 className="text-2xl font-semibold text-astro">{thought}</h3>
            <p className="text-gray-600 mt-2">Read our latest perspective on how astrology and finance align.</p>
          </div>
        ))}
      </section>

      {/* Call to Action */}
      <section className="mt-20 text-center">
        <h2 className="text-3xl font-bold">Have Your Own Thoughts?</h2>
        <p className="mt-2 text-gray-700">Share your market insights with the community.</p>
        <button className="mt-6 px-6 py-3 bg-gold text-[#041c16] rounded-lg shadow-md hover:bg-opacity-90 transition">Share Your Thoughts</button>
      </section>
    </div>
  </>
  );
};

export default ThoughtsPage;
